import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ArrowDefaultIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23 11H3.61L12.44 3.04C12.85 2.67 12.88 2.04 12.51 1.63C12.14 1.22 11.51 1.19 11.1 1.56L0.33 11.26C-0.11 11.64 -0.11 12.37 0.33 12.75L11.11 22.45C11.52 22.82 12.15 22.79 12.52 22.38C12.89 21.97 12.86 21.34 12.45 20.97L3.61 13H23C23.55 13 24 12.55 24 12C24 11.45 23.55 11 23 11Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ArrowDefaultIcon.displayName = 'ArrowDefaultIcon';
